import React, { useState, useEffect, useRef } from 'react';
import { Button, Container, Form, Row } from 'react-bootstrap';
import { db } from '../firebase-config';
import { doc, getDoc, setDoc } from "firebase/firestore";
// import { useNavigate } from 'react-router-dom';

import { useAuth } from '../Context/AuthContext';
import StatusSpinner from '../Components/StatusSpinner';

import { toast } from 'react-toastify';

// const navigate = useNavigate();

export default function EmployeeEmailLists() {
    const { showSpinner, setShowSpinner } = useAuth();
    const [requestEmailList, setRequestEmailList] = useState([]);
    const textInputRefs = useRef([]);

    useEffect(()=>{
        textInputRefs.current[requestEmailList.length-1]?.focus();
    }, [requestEmailList.length]);

    useEffect(()=>{
        setShowSpinner(true);
        const requestDocRef = doc(db, 'email_lists', 'request_list');
        getDoc(requestDocRef).then((snapshot)=>{
            if(snapshot.exists()){
                setRequestEmailList(snapshot.data().emails)
            }else{
                setRequestEmailList([]);
            }
            setShowSpinner(false);
        }).catch((error)=>{
            setShowSpinner(false);
            toast.error(`Error loading email list: ${error.message}`);
            toast.error(`Please reload and try again`);
        });
    }, [setShowSpinner]);

    const emailValidity = (tempList)=>{
        let allEmailsValid = true;
        for(let x=0; x<tempList.length; ++x){
            if(tempList[x].includes("@") && tempList[x].includes(".")){
                const prefix = tempList[x].split("@")[0];
                allEmailsValid = /^(?!^\.)(?!.*[-_.]$)(?!\.)(?!.*\.$)(?!.*?\.\.)[-.0-9_a-zA-Z]+$/.test(prefix);
                if(!allEmailsValid){
                    break;
                }
                const domain = tempList[x].split("@")[1];
                const portionFirst = domain.split(".")[0];
                const portionLast = domain.split(".")[1];
                allEmailsValid = /^[-0-9a-zA-Z]+$/.test(portionFirst);
                if(!allEmailsValid){
                    break;
                }
                if(typeof portionLast === 'string'){
                    if(portionLast.length < 2){
                        allEmailsValid = false;
                        break;
                    }
                }else{
                    allEmailsValid = false;
                    break;
                }
            }else{
                allEmailsValid = false;
                break;
            }

        }
        return allEmailsValid;
    };

    const saveEmailList = ()=>{
        // double check email validity
        // empty field - remove
        const tempList = requestEmailList.filter(email => email !== "");
        if(emailValidity(tempList)){
            const requestDocRef = doc(db, 'email_lists', 'request_list');
            setDoc(requestDocRef,
                {
                    emails: tempList,
                }
            ).then(()=>{
                setRequestEmailList(tempList);
                toast.success(`Email list updated`);
            }).catch((error)=>{
                toast.error(`Error saving to database: ${error.message}`);
                toast.error(`Please reload and try again`);
            });
        }else{
            toast.warning(`All emails on the list must be valid which includes a prefix, an "@" symbol, a domain and a "." symbol`);
            toast.warning(`Please double check all email addresses in the list`);
        }
    };

    const fieldUpdated = (event:any, fieldIndex:number) =>{
        //toast(`field updated: ${event.target.value} : ${fieldIndex}`);
        // -1 means add to end of array
        if(fieldIndex === -1){
            setRequestEmailList([...requestEmailList, event.target.value]);
        }
        if(fieldIndex !== -1){
            const tempList = requestEmailList.map((email, listIndex) => {
                if (fieldIndex === listIndex) {
                  return event.target.value;
                } else {
                  return email;
                }
            });
            setRequestEmailList(tempList);
        }
    };


    return(
        <>
            <Container fluid style={{width:"100%",paddingLeft:"65px", marginRight:"65px"}}>
                <Container fluid className="mt-5" style={{fontSize:"1.5em", letterSpacing:"0.2em"}}>
                    <Row className="justify-content-center">
                        Admin Email Lists
                    </Row>
                </Container>
            </Container>
            <Container fluid className="d-flex align-items-center justify-content-center" style={{width:"100%", paddingLeft:"70px", marginRight:"70px"}}>
                <div className="w-100" style={{maxWidth: "600px"}}>
                    <div className="mt-5" style={{maxWidth: "600px", textAlign:"left"}}>
                        <Form.Label>New Request Email List:</Form.Label>
                        <div className="w-100" style={{maxWidth: "600px"}}>
                            {
                                requestEmailList.map((email, index)=>(
                                    <div key={index}><Form.Control className="mt-2" type="email" value={email} onChange={(e)=> fieldUpdated(e, index)} id={`${index}`} ref={(ref) => textInputRefs.current[index] = ref} /></div>
                                ))
                            }
                            <div><Form.Control className="mt-2" type="email" value="" onChange={(e)=> fieldUpdated(e, -1)}  /></div>
                        </div>
                        <div className="mt-3" style={{textAlign:"center"}}>
                            <Button
                                className="btn-dark"
                                style={{backgroundColor:"#2596be", margin:5}}
                                onClick={()=>{
                                    saveEmailList();
                                }}
                            >
                                Save
                            </Button>
                        </div>
                    </div>
                </div>
            </Container>

            {
                showSpinner &&
                <StatusSpinner />
            }
        </>
    );
}